module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'wi1wt8v3',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
